import {
  constants,
  mediaQueryStyles as mediaQuery,
  typographyStyles,
} from "@newsela/angelou";

import { globalRowWrapperPadding as rowPadding } from "@/browse/browse.constants.js";

const textMObj = typographyStyles.textMObj;
const mq = mediaQuery.mediaQuery;

export const tryAgainButtonWrapRowCss = {
  root: { marginTop: "1rem" },
};

export const errorContainerWrapRowCss = {
  ...textMObj,
  fontWeight: "bold",
  textAlign: "center",
};

export const noResultsMessageWrapRowCss = {
  ...textMObj,
  fontWeight: "bold",
  textAlign: "center",
  fontFamily: typographyStyles.fontFamily.circular,
};

export const cardCss = {
  height: "388px",
  backgroundColor: "#e9e5de",
  borderRadius: "5px",
  margin: "1em",

  [mq.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: `${rowPadding.smallUp}`,
  },
};

export const cardRowWrapperCss = {
  display: "flex",
  flexDirection: "column",
  flex: "1",
};

export const cardWrapRowCss = {
  minWidth: "100%",
  display: "grid",
  gridGap: "1em",
  /* define the number of grid columns */
  gridTemplateColumns: "repeat(1, 1fr)",
  gridAutoRows: "458px",

  [mq.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  [mq.downTo(constants.breakpoints.BreakpointNames.md)]: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },

  [mq.downTo(constants.breakpoints.BreakpointNames.lg)]: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
};

const DEFAULT_GRID_ROW_HEIGHT = 388;
export const contentSettingsWrapRowCss = (totalGroups) => ({
  gridAutoRows: DEFAULT_GRID_ROW_HEIGHT + totalGroups * 36,
});
